<template>
  <b-container>
    <h1>{{ $t("user.importTitle") }}</h1>

    <success-fade-alert ref="successFadeAlert" :msg="alert.success" />
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />

    <b-row>
      <b-col sm="12" md="12" lg="12">
        <b-form-group label="Anexo" label-for="file">
          <b-form-file
            :lang="$i18n.locale"
            id="file"
            ref="file"
            :placeholder="$t('geral.escolhaArquivo')"
            v-on:change="handleFileUpload($event)"
            :no-drop="true"
          ></b-form-file>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-button type="submit" variant="primary" v-on:click="submitFile()">
        {{ $t("geral.import") }}
      </b-button>
    </b-row>
  </b-container>
</template>

<script>
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";
export default {
  components: {
    "success-fade-alert": SuccessFadeAlert,
    "fade-alert-danger": FadeAlertDanger,
    // "import-status": CargoImportStatus,
  },
  data: function () {
    return {
      file: null,
      importacaoId: null,
      alert: {
        error: "",
        success: "",
      },
    };
  },
  methods: {
    handleFileUpload(e) {
      this.file = e.target.files[0];
    },

    submitFile() {
      if (this.file != null) {
        console.log(this.file);
        let formData = new FormData();
        formData.append("file", this.file);

        this.$apiScheduler
          .post("/profile/import", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((data) => {
            console.log("sucesso!");
            console.log(data.data);
            // this.$refs.cargoImportStatus.finishProcess();
            this.alert.success = this.$t("user.importSuccess"); //data.data.message;
            this.$refs.successFadeAlert.show();
          })
          .catch((error) => {
            console.log(error.response);
            if (error.response) {
              this.alert.error = error.response.data.detail;
              this.$refs.fadeAlertDanger.show();
            } else {
              this.alert.error = error.message;
              this.$refs.fadeAlertDanger.show();
            }
          });
      }
    },
  },
};
</script>
